"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmulatedDeliveryEvents = void 0;
var EmulatedDeliveryEvents;
(function (EmulatedDeliveryEvents) {
    EmulatedDeliveryEvents["AssignDriverAndStart"] = "AssignDriverAndStart";
    EmulatedDeliveryEvents["CancelOrder"] = "CancelOrder";
    EmulatedDeliveryEvents["FinishOrder"] = "FinishOrder";
    EmulatedDeliveryEvents["CheckInPickUp"] = "CheckInPickUp";
    EmulatedDeliveryEvents["CheckOutPickUp"] = "CheckOutPickUp";
    EmulatedDeliveryEvents["CheckInDropOff"] = "CheckInDropOff";
    EmulatedDeliveryEvents["CheckOutDropOff"] = "CheckOutDropOff";
})(EmulatedDeliveryEvents || (exports.EmulatedDeliveryEvents = EmulatedDeliveryEvents = {}));
//# sourceMappingURL=emulated_delivery_provider_types.js.map